import { jsx as o, Fragment as n } from "react/jsx-runtime";
import { useState as d, useEffect as l } from "react";
import { NotificationBar as c } from "@nextgen-web-framework/all";
import { StorageService as e } from "@nextgen-web-framework/core";
import { LocalStorageKeys as r } from "../../utils/common.js";
import '../../assets/Notification.css';const s = "#ffffff", V = "#396e75", g = "#e5fdff", f = "#546223", z = "#f0fae5", C = "#a65523", u = "#fff1e8", k = "#7f3e3e", m = "#ffe2e2", h = "#62625a", B = "#f8f8e7", O = "#38539a", _ = "#707070", N = "#c8f8d1", S = "#87c9c8", b = "#5291b1", v = "rgba(82, 145, 177, 0.1019607843)", w = "#445685", R = "#181d61", I = "rgba(24, 29, 97, 0.1019607843)", G = "#5969d6", y = "#ea999d", W = "#b6577e", E = "rgba(182, 87, 126, 0.1019607843)", A = "#7e3e80", T = "#1e247f", Y = "rgba(30, 36, 127, 0.1019607843)", F = "#da7600", L = "#107f47", x = "#d91734", M = "_html_unovr_38", P = {
  amwayWhite: s,
  darkBlue: V,
  lightBlue: g,
  darkGreen: f,
  lightGreen: z,
  darkOrange: C,
  lightOrange: u,
  darkRed: k,
  lightRed: m,
  darkYellow: h,
  lightYellow: B,
  darkPurple: O,
  darkGrayOnWhite: _,
  dataVizColor1: N,
  dataVizColor2: S,
  dataVizColor3: b,
  dataVizColor3Background: v,
  dataVizColor4: w,
  dataVizColor5: R,
  dataVizColor5Background: I,
  dataVizColor6: G,
  dataVizColor7: y,
  dataVizColor8: W,
  dataVizColor8Background: E,
  dataVizColor9: A,
  dataVizColor10: T,
  dataVizColor10Background: Y,
  dataVizAlertOrange: F,
  dataVizSuccessGreen: L,
  dataVizWarningRed: x,
  "no-visible": "_no-visible_unovr_34",
  html: M
}, J = (a) => {
  const [i, t] = d(!1);
  return l(() => {
    t((() => a._version ? Number(
      e.getLocalStorage().retrieve(r.NOTIFICATION_VERSION_NUMBER)
    ) !== a._version : !1)());
  }, [a._version]), /* @__PURE__ */ o(n, { children: i && /* @__PURE__ */ o(
    "div",
    {
      className: P["notificationbar-container"],
      id: "notificationbar-id",
      "data-testid": "notification-test-id",
      "data-pod-name": "commerce",
      children: /* @__PURE__ */ o(
        c,
        {
          message: a.message,
          iconClickHandler: () => {
            t(!1), e.getLocalStorage().store(r.NOTIFICATION_VERSION_NUMBER, a._version);
          }
        }
      )
    }
  ) });
};
export {
  J as default
};
//# sourceMappingURL=Notification.js.map
